console.log("js/review-form.js -> v0.1.0");

const setIndexedProperty = ($element, property, id, index) =>
	$element.prop(property, `r_${id}_${index + 1}`);

$("body").css("background-color", "#fff");

document.querySelectorAll(".star-rating").forEach((starRating) => {
	const stars = starRating.querySelectorAll(".star");
	const inputs = starRating.querySelectorAll("input");

	// Handle click event (persistent highlight)
	stars.forEach((star, index) => {
		star.addEventListener("click", () => {
			stars.forEach((s, i) => {
				s.classList.toggle("highlight", i <= index);
			});
		});
	});

	// Handle hover effect
	stars.forEach((star, index) => {
		star.addEventListener("mouseenter", () => {
			stars.forEach((s, i) => {
				s.classList.toggle("hover", i <= index);
			});
		});

		star.addEventListener("mouseleave", () => {
			stars.forEach((s) => s.classList.remove("hover"));
		});
	});

	// Ensure that checked state remains after hover
	inputs.forEach((input) => {
		input.addEventListener("change", () => {
			const selectedIndex = [...inputs].indexOf(input);
			stars.forEach((star, i) => {
				star.classList.toggle("highlight", i <= selectedIndex);
			});
		});
	});
});

document.addEventListener("DOMContentLoaded", () => {
	document.body.addEventListener("click", (event) => {
		if (event.target.classList.contains("js-instructor-label")) {
			const parent = event.target.closest(
				".review-form__instructor-ratings"
			);
			const stars = parent.querySelectorAll(".js-instructor-label");
			const inputs = parent.querySelectorAll(".js-instructor-input");

			const index = [...stars].indexOf(event.target); // Get clicked star index

			// Highlight clicked and previous stars
			stars.forEach((s, i) => {
				s.classList.toggle("highlight", i <= index);
			});

			// Check corresponding radio input
			if (inputs[index]) inputs[index].checked = true;
		}
	});

	document.body.addEventListener("mouseover", (event) => {
		if (event.target.classList.contains("js-instructor-label")) {
			const parent = event.target.closest(
				".review-form__instructor-ratings"
			);
			const stars = parent.querySelectorAll(".js-instructor-label");

			const index = [...stars].indexOf(event.target);

			// Apply hover effect
			stars.forEach((s, i) => {
				s.classList.toggle("hover", i <= index);
			});
		}
	});

	document.body.addEventListener("mouseout", (event) => {
		if (event.target.classList.contains("js-instructor-label")) {
			const parent = event.target.closest(
				".review-form__instructor-ratings"
			);
			const stars = parent.querySelectorAll(".js-instructor-label");

			// Remove hover effect
			stars.forEach((s) => s.classList.remove("hover"));
		}
	});

	// Ensure selected state persists on radio input change
	document.body.addEventListener("change", (event) => {
		if (event.target.classList.contains("js-instructor-input")) {
			const parent = event.target.closest(
				".review-form__instructor-ratings"
			);
			const stars = parent.querySelectorAll(".js-instructor-label");
			const inputs = parent.querySelectorAll(".js-instructor-input");

			const index = [...inputs].indexOf(event.target);

			// Keep highlight on selected stars
			stars.forEach((star, i) => {
				star.classList.toggle("highlight", i <= index);
			});
		}
	});
});

$(() => {
	const hasLength = (value) => value && value.length && value.length > 0;
	const capitalize = (text) => `${text[0].toUpperCase()}${text.slice(1)}`;

	const getReviewerFromCountry = (reviewer, country) =>
		reviewsTransTags.review_by_customer_from_country_customer
			.replace("CUSTOMER", `<br /><b>${reviewer}</b>`)
			.replace("COUNTRY", country);

	const getCredit = (isAnonymous, name, country) =>
		isAnonymous
			? reviewsTransTags.review_by_customer_from_country_anonymous
			: getReviewerFromCountry(name, country);

	const buildRow = (text, image) =>
		hasLength(text)
			? $("<div>", { class: "review__row" }).append(
					$("<div>", { class: "review__thumbs" }).append(
						$(`<i class="ebs-icon ebs-icon-t-${image}"></i>`)
					),
					$("<div>", { class: "review__text", text })
			  )
			: null;

	const buildRating = (rating) => {
		rating = rating > 10 ? rating / 10 : rating;

		const stars = [
			[
				$('<i class="ebs-icon ebs-icon-t-star-half"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-empty"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-empty"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-empty"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-empty"></i>'),
			],
			[
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-empty"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-empty"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-empty"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-empty"></i>'),
			],
			[
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-half"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-empty"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-empty"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-empty"></i>'),
			],
			[
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-empty"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-empty"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-empty"></i>'),
			],
			[
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-half"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-empty"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-empty"></i>'),
			],
			[
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-empty"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-empty"></i>'),
			],
			[
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-half"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-empty"></i>'),
			],
			[
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-empty"></i>'),
			],
			[
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-half"></i>'),
			],
			[
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
				$('<i class="ebs-icon ebs-icon-t-star-full"></i>'),
			],
		];

		return rating == 0
			? []
			: stars.find((star, index) => index + 2 > rating);
	};

	const buildRatings = (review) => {
		return $("<div>", { class: "review__ratings" }).append(
			Object.keys(review.scores).map((key) =>
				review.scores[key] > 0
					? $("<div>").append(
							$("<p>", {
								class: "rating-label",
								html: reviewsTransTags[key] + ": ",
							}),
							$("<p>", {
								class: "rating-score",
								html: buildRating(review.scores[key]),
							})
					  )
					: ""
			)
		);
	};

	const buildRebrandReview = (review) =>
		$("<div>", { class: "review" }).append(
			$("<div>", {
				class: "review__credit",
				html: getCredit(
					review.isAnonymous,
					review.customerName,
					review.countryName
				),
			}),
			$("<div>", {
				class: "review__date",
				html: `${reviewsTransTags.date}: <br /><b>${review.createdDate}</b>`,
			}),
			$("<div>", { class: "review__content" }).append(
				hasLength(review.reviewHighlight)
					? $("<div>", { class: "review__highlight-wrapper" }).append(
							$("<h3>", {
								class: "title review__highlight",
								text: `"${review.reviewHighlight}"`,
							})
					  )
					: null,
				buildRow(review.reviewTextPros, "thumbs-up"),
				buildRow(review.reviewTextCons, "thumbs-down"),
				$("<div>", { class: "review__ratings-wrapper" }).append(
					buildRatings(review)
				)
			)
		);

	$("body").on("change", ".review-form__radio", (event) => {
		const radio = $(event.target);
		const rating = radio.val();
		const item = radio.closest(
			".review-form__item, .review-form__instructor-ratings"
		);

		const comments = item.find(`.review-form__comment`);
		comments.removeClass("show");

		const comment = comments.filter(`[data-value="${rating}"]`);
		comment.addClass("show");
	});

	$("body").on("change", ".review-form__instructor-select", (event) => {
		const select = $(event.target);
		const selected = select.find(":selected");
		const id = selected.data("id");
		const selectedText = selected.text(); // Get the selected option text
	
		const ratings = select.siblings(".review-form__instructor-ratings");
		ratings.removeClass("hide");
	
		const inputs = ratings.find(".js-instructor-input");
		inputs.each((index, input) => {
			const $input = $(input);
			$input.prop("name", `instructor_${id}`);
			setIndexedProperty($input, "id", id, index);
		});
	
		const labels = ratings.find(".js-instructor-label");
		labels.each((index, label) => {
			const $label = $(label);
			setIndexedProperty($label, "for", id, index);
		});
	
		ratings.removeClass("hide");
	
		// Add or update the <p> tag with the selected value
		let selectedTextParagraph = select.next(".selected-instructor-text");
	
		if (selectedTextParagraph.length) {
			selectedTextParagraph.text(`${selectedText}`);
		} else {
			selectedTextParagraph = $(
				`<p class="selected-instructor-text">${selectedText}</p>`
			);
			select.after(selectedTextParagraph);
		}
	
		// Check if remove button wrapper already exists
		const parent = select.closest(".js-review-form__instructor-item");
		let removeWrapper = parent.find(".remove-instructor-wrapper");
	
		if (!removeWrapper.length) {
			removeWrapper = $('<div class="remove-instructor-wrapper"></div>');
	
			const removeButton = $(
				'<button class="remove-instructor"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18" stroke="#2A3735" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6 6L18 18" stroke="#2A3735" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>'
			);
	
			removeButton.click(function () {
				const totalInstructors = $(".remove-instructor-wrapper").length;
	
				if (totalInstructors > 1) {
					// If more than one instructor exists, remove this one
					parent.remove();
				} else {
					// If it's the last one, reset the select field
					select.val("").trigger("change"); // Reset selection
					$('.selected-instructor-text').remove();
					$('.review-form__instructor-title').remove();
					ratings.addClass("hide"); // Hide ratings
					selectedTextParagraph.remove(); // Remove the selected instructor text
					removeWrapper.remove(); // Remove the button wrapper
				}
	
				updateAddButtonVisibility();
			});
	
			removeWrapper.append(removeButton);
	
			// Insert remove button wrapper **before** the selected-instructor-text
			selectedTextParagraph.before(removeWrapper);
		}
	
		updateAddButtonVisibility();
	});

	const updateAddButtonVisibility = () => {
		const items = $(".remove-instructor-wrapper"); // Only counting remove buttons
		const addButton = $(".review-form__add-button");
	
		if (items.length) {
			addButton.removeClass("hide");
		} else {
			addButton.addClass("hide");
		}
	};

	const addInstructor = () => {
		const items = $(".js-review-form__instructor-item");
		const item = $(items[0]);
		const clone = item.clone();
		const instructorsTitle = $("#instructor-review-question");
		const instructorTitle = clone.find("h2");
	
		if (items.length === 1) {
			instructorTitle.remove();
		} else {
			instructorTitle.text(instructorsTitle.text());
		}
	
		clone.removeClass("hide");
	
		// Remove any existing selected text, ratings, and remove button
		clone.find(".selected-instructor-text").remove();
		clone.find(".review-form__instructor-ratings").addClass("hide");
		clone.find(".remove-instructor-wrapper").remove();
		clone.find(".selected-instructor-text").remove();
		clone.find(".review-form__instructor-select").val("").trigger("change"); // Reset selection
	
		clone.appendTo(".review-form__instructors");
	
		updateAddButtonVisibility();
	};

	addInstructor();
	$(".review-form__add-button").click(addInstructor);

	updateAddButtonVisibility();

	$(document).on("click", ".remove-instructor", function () {
		$(this).closest(".js-review-form__instructor-item").remove();
		updateAddButtonVisibility(); // Update button visibility after removal
	});

	// character count for the textarea
	$("#review-text-pros").keyup(function () {
		var characterCount = $(this).val().length;
		var current = $(this).next().find(".current");
		var counter = $(this).next(".character-count");

		current.text(characterCount);

		if (characterCount <= 1250) {
			counter.css("color", "#7C8086");
		}
		if (characterCount > 1250) {
			counter.css("color", "#FABC42");
		}
		if (characterCount > 1400) {
			counter.css("color", "#A32F15");
		}
	});

	// character count for the textarea
	$("#review-text-cons").keyup(function () {
		var characterCount = $(this).val().length;
		var current = $(this).next().find(".current");
		var counter = $(this).next(".character-count");

		current.text(characterCount);

		if (characterCount <= 1250) {
			counter.css("color", "#7C8086");
		}
		if (characterCount > 1250) {
			counter.css("color", "#FABC42");
		}
		if (characterCount > 1400) {
			counter.css("color", "#A32F15");
		}
	});

	const buildReview = () => {
		const input = $(".review-form__data");

		const currentDate = new Date();
		const date = currentDate.getDate();
		const month = currentDate.toLocaleString("en-us", { month: "long" });
		const year = currentDate.getFullYear();
		const dateString = `${month} ${date}, ${year}`;

		const getScore = (name) => {
			const element = $(`input[name=${name}]:checked`);
			return element.length ? element.val() : 0;
		};

		const data = {
			isAnonymous: $(".review-form__is-anonymous").is(":checked"),
			customerName: input.data("name"),
			countryName: input.data("country"),
			createdDate: dateString,
			reviewHighlight: $(".review-form__title-input").val(),
			reviewTextCons: $(".review-form__bad-input").val(),
			reviewTextPros: $(".review-form__good-input").val(),
			organizerReply: "",
			scores: {
				accommodationAndFacilities: getScore(
					"accommodationAndFacilities"
				),
				food: getScore("food"),
				location: getScore("location"),
				overallImpression: getScore("overallImpression"),
				qualityOfActivity: getScore("qualityOfActivity"),
				valueForMoney: getScore("valueForMoney"),
			},
		};

		const review = buildRebrandReview(data);

		const oldReview = $(".review-form__preview");
		oldReview.remove();

		const newReview = $("<div>", { class: "review-form__preview" });
		newReview.append(review);

		// Clone the .review__card, add an extra class, and append it
		const reviewCard = $(".review__card")
			.clone(true, true)
			.addClass("new-review-style");
		newReview.append(reviewCard);

		$(".review-form__preview-target").prepend(newReview);
	};

	$(".review-form__form").change(() => {
		buildReview();
	});

	$("document").ready(() => {
		if (typeof getUrlParameter == "function") {
			var refItem = getUrlParameter("refItem");
			var refValue = getUrlParameter("refValue");
			if (refItem && refValue) {
				var target = document.getElementById("ri" + refItem + refValue);

				if (target) {
					target.checked = true;
				}
			}
		}
	});
});
